import PeopleSchemaSerializer from './base';

export default class Group extends PeopleSchemaSerializer {}
